export namespace IHome {

  export const Action = 'MainScreen';
  export enum Command {
    Get = 'get',
    Set = 'set',
    GetFavoriteCars = 'getFavoriteCars',
    GetMyCars = 'getMyCars',
  }

  export interface IData {
    balance: number;
    extModeFlag: boolean;
    requestAccessFlag: boolean;
    persName: string;
    favoriteCars: IFavoriteCar[];
  }

  export interface IFavoriteCar {
    carId: number;
    carNumber: string;
    tSum: number;
    parkName: string;
    dateBeg: string;
    theftFlag: boolean;
  }

  export enum EmitterEvents {
    UpdateCarInfo = 'home-page:update-car-info',
  }
}
